import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import PhoneInput from "react-phone-number-input";
import { useDispatch, useSelector } from "react-redux/es/exports";
import { useLocation } from "react-router-dom";
import { setApplicationInfo } from "../../../redux/slice/customer/customerSlice";
import { fetchAllStates } from "../../../redux/slice/staff/staffSlice";
import { contactSchema } from "../../../utils/validators/schema";
import { states_cities } from "../../../utils/data/states_cities";
import { useRef } from "react";
import { flashMessage } from "./../../../utils/flash/index";

const ContactInformation = ({ idInfoRef }) => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [selectedState, setSelectedState] = useState([]);
  const [cities, setCities] = useState([]);
  let phoneNumberRef = useRef();

  const onSubmit = (values) => {
    if (!phoneNumber) {
      flashMessage("error", "please enter phone number");
    } else {
      let contact_info = { ...values, phone_number: phoneNumber };
      dispatch(setApplicationInfo({ ...contact_info }));
      idInfoRef.current.click();
    }
  };

  // useFormik validation
  const { values, errors, handleChange, handleBlur, handleSubmit, touched } =
    useFormik({
      initialValues: {
        email: "",
        phone_number: "",
        city: "",
        town: "",
        business_address: "",
        state: "",
      },
      validationSchema: contactSchema,
      onSubmit,
    });

  const dispatch = useDispatch();
  const location = useLocation();

  const handlePhoneNumberChange = (phone_no) => {
    setPhoneNumber(phone_no);
    dispatch(setApplicationInfo({ phone_number: phone_no }));
  };

  // initialize redux state
  useEffect(() => {
    dispatch(setApplicationInfo(values));
  }, [values]);

  return (
    <div className='border border-top-0 px-3 py-3'>
      {/* 
             residential/business adres, city/town 
            */}
      <form onSubmit={handleSubmit}>
        <div className='row mb-2'>
          <div className='mb-0 mt-3 col-md-6'>
            <label
              htmlFor='inputEmail4'
              className='form-label d-flex align-baseline'
            >
              <span>Company Email</span>
              <span className='text-danger'>*</span>
            </label>
            <input
              name='email'
              type='email'
              id='email'
              value={values.email}
              onChange={handleChange}
              onBlur={handleBlur}
              className={`form-control ${
                errors.email && touched.email ? "is-invalid" : ""
              }`}
              placeholder='Enter Email'
            />
            {errors.email && touched.email && (
              <span className='invalid-feedback'> {errors.email} </span>
            )}
          </div>
          <div className='col-md-6 mt-3'>
            <label htmlFor='inputEmail4' className='form-label'>
              Company Phone number
              <span className='text-danger'>*</span>
            </label>

            <PhoneInput
              ref={phoneNumberRef}
              placeholder='Enter company phone number'
              name='phone_number'
              value={phoneNumber}
              onChange={handlePhoneNumberChange}
              defaultCountry='NG'
              className='form-control custom-phone-input'
            />
          </div>

          <div className='mb-0 mt-3 col-md-12'>
            <label
              htmlFor='inputEmail4'
              className='form-label d-flex align-baseline'
            >
              <span>State</span>
              <span className='text-danger'>*</span>
            </label>
            <select
              name='state'
              type='state'
              id='state'
              value={values.state}
              onChange={handleChange}
              onBlur={handleBlur}
              className={`form-control ${
                errors.state && touched.state ? "is-invalid" : ""
              }`}
            >
              <option value=''>-- select an option --</option>
              {states_cities?.map(({ name }, index) => (
                <option key={index} value={name}>
                  {name}
                </option>
              ))}
            </select>
            {errors.state && touched.state && (
              <span className='invalid-feedback'> {errors.state} </span>
            )}
          </div>

          <div className='mb-0 mt-3 col-md-6'>
            <label
              htmlFor='inputEmail4'
              className='form-label d-flex align-baseline'
            >
              <span>City</span>
              <span className='text-danger'>*</span>
            </label>
            <select
              disabled={values?.state?.length === 0 ? true : false}
              name='city'
              type='city'
              id='city'
              value={values.city}
              onChange={handleChange}
              onBlur={handleBlur}
              className={`form-select ${
                errors.city && touched.city ? "is-invalid" : ""
              }`}
            >
              <option value=''>-- select an option --</option>
              {states_cities
                ?.filter((f) => f.name == values?.state)[0]
                ?.cities?.map((city, index) => (
                  <option key={index} value={city}>
                    {" "}
                    {city}{" "}
                  </option>
                ))}
            </select>
            {errors.city && touched.city && (
              <span className='invalid-feedback'> {errors.city} </span>
            )}
          </div>

          <div className='mb-0 mt-3 col-md-6'>
            <label
              htmlFor='inputEmail4'
              className='form-label d-flex align-baseline'
            >
              <span>Town</span>
            </label>
            <input
              name='town'
              id='town'
              value={values.town}
              onChange={handleChange}
              onBlur={handleBlur}
              className={`form-control ${
                errors.town && touched.town ? "is-invalid" : ""
              }`}
              placeholder='Enter town here'
            />
            {errors.town && touched.town && (
              <span className='invalid-feedback'> {errors.town} </span>
            )}
          </div>

          <div className='mb-0 mt-3 col-md-12'>
            <label
              htmlFor='inputEmail4'
              className='form-label d-flex align-baseline'
            >
              <span>Business Address </span>
            </label>
            <textarea
              rows={3}
              name='business_address'
              id='business_address'
              value={values.business_address}
              onChange={handleChange}
              onBlur={handleBlur}
              className={`form-control ${
                errors.business_address && touched.business_address
                  ? "is-invalid"
                  : ""
              }`}
            ></textarea>
            {errors.business_address && touched.business_address && (
              <span className='invalid-feedback'>
                {" "}
                {errors.business_address}{" "}
              </span>
            )}
          </div>
        </div>
        <div className='d-flex justify-content-end mb-3'>
          <button type='submit' className='btn btn-primary'>
            Proceed
          </button>
        </div>
      </form>
    </div>
  );
};

export default ContactInformation;
